import _ from 'lodash';
import VError from 'verror';
import { proxyFetch as copilotProxyFetch } from '@janus.team/janus-copilot';
import * as Sentry from '@sentry/browser';
import { copilotApplicationContainerProps, isRacker, baseUrl } from './config';

export const parseResponse = (res) => res.text().then((body) => {
  let info = {};
  try {
    info = {
      status: res.status,
      body: JSON.parse(body),
      url: res.url,
    };
    if (!res.ok) {
      const error = Promise.reject(new VError({
        name: 'HttpError',
        info,
      }, `response status was not ok (${res.status})`));
      Sentry.captureException(error);
      return error;
    }
    return _.isEmpty(body) ? {} : JSON.parse(body);
  } catch (error) {
    Sentry.captureException(error);
    return Promise.reject(new VError({
      name: 'ApiError',
      cause: error,
      info,
    }, 'response body was not json'));
  }
});

export const proxyFetch = (url = '/', fetchConfig = {}, options = {}) => copilotProxyFetch(
  `${baseUrl()}/ui-proxy/${isRacker() ? 'r' : 'c'}/${encodeURIComponent(url)}`,
  _.merge(_.pick(copilotApplicationContainerProps(), ['credentials']), fetchConfig),
  _.merge(copilotApplicationContainerProps(), { racker: isRacker() }, options),
);

export default proxyFetch;
